import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { replace } from 'lodash-es';

@Pipe({
    name: 'unsafeHtml',
    standalone: false
})
export class UnsafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: string) {
    value = replace(value, /&lt;/g, '<');
    value = replace(value, /&gt;/g, '>');
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
